import React from 'react';
import NoSSR from 'react-no-ssr';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import Ad from '@ifeng/ui_pc_ad';
import errorBoundary from '@ifeng/errorBoundary';
import PBSiderBox from './pbSiderBox';
import IpadAd from '../../../components/ipadAd';

class PBNewsSider extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { pbNewsSiderContent, hbNewsSiderAd, ipadAd3 },
        } = this.props;

        return (
            <div id="homeSiderList" className={styles.sider_box}>
                <div className={styles.sider}>
                    <Chip
                        id="200035"
                        type="struct"
                        title="互娱有声左侧栏"
                        groupName="智库文化要闻区左侧栏"
                        content={pbNewsSiderContent}
                        position="relative">
                        <PBSiderBox />
                    </Chip>
                </div>
                <NoSSR>
                    {hbNewsSiderAd ? (
                        <Ad content={hbNewsSiderAd} />
                    ) : (
                        <Chip id="40105" type="static" title="广告4" groupName="智库文化要闻区左侧栏" content={ipadAd3}>
                            <IpadAd />
                        </Chip>
                    )}
                </NoSSR>
            </div>
        );
    }
}

export default errorBoundary(PBNewsSider);
